import { Props } from './interfaces';
import styles from './shipping-and-pay-information.module.scss';
import PaymentInformation from '../payment-information';
import ShippingInformation from '../shipping-information';

const ShippingAndPayInformation = ({ order }: Props) => {
  return (
    <div className={styles['container']}>
      <ShippingInformation order={order} />
      <hr />
      <PaymentInformation order={order} />
    </div>
  );
};

export default ShippingAndPayInformation;
